define(['angular'], function(angular) {


    function ContractProvider() {
        let bdcUrl;

        /**
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                let self = {};

                /**
                 * Create or update a contract
                 * @param  {Object} data
                 * @return {Promise}
                 */
                self.createUpdate = function createUpdate(data) {
                    return $http.post(bdcUrl + 'contract', data).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Get contracts
                 * @param {Object} opts
                 * @param {String} opts.offset
                 * @param {Array}  opts.rds
                 * @param {Array}  opts.drv
                 * @param {Array}  opts.partner
                 * @param {Array}  opts.market
                 * @param {Array}  opts.network
                 * @param {Array}  opts.telepro --> concatenated with rds filter to see who created the contract
                 * @param {Array}  opts.csd --> concatenated with rds filter to see who created the contract
                 * @param {Array}  opts.cup --> concatenated with rds filter to see who created the contract
                 * @param {Array}  opts.formerRDS --> concatenated with rds filter to see who created the contract
                 * @param {int}  opts.signed
                 * @param {String} opts.identifiant
                 * @param {String} opts.agent
                 * @param {String} opts.dateStart
                 * @param {String} opts.dateEnd
                 * @param {String} opts.creationDateStart
                 * @param {String} opts.creationDateEnd
                 * @param {String} opts.signatureMonth
                 * @param {String} opts.installationMonth
                 * @param {String} opts.limit
                 * @param {int} opts.cancelled
                 * @param {int} opts.jdsInjected
                 * @return {Promise}
                 */
                self.getContracts = function(opts) {
                    let baseUrl = bdcUrl + 'contracts?limit=' + opts.limit + '&offset=' + opts.offset * opts.limit;

                    baseUrl +=
                        '&rds=[' + opts.rds.concat(opts.telepro, opts.csd, opts.cup, opts.formerRDS).join(',') + ']';
                    baseUrl += '&drv=[' + opts.drv.join(',') + ']';
                    baseUrl += '&partner=[' + opts.partner.join(',') + ']';
                    baseUrl += '&market=[' + opts.market.join(',') + ']';
                    baseUrl += '&network=[' + opts.network.join(',') + ']';

                    if (opts.signed !== undefined && opts.signed !== null) {
                        baseUrl += '&signed=' + opts.signed;
                    }

                    if (opts.identifiant !== undefined && opts.identifiant !== null) {
                        baseUrl += '&identifiant=' + opts.identifiant;
                    }

                    if (opts.agent !== undefined && opts.agent !== null) {
                        baseUrl += '&agent=' + opts.agent;
                    }

                    if (opts.updateDateStart !== undefined && opts.updateDateStart !== null) {
                        baseUrl += '&updateDateStart=' + opts.updateDateStart;
                    }

                    if (opts.updateDateEnd !== undefined && opts.updateDateEnd !== null) {
                        baseUrl += '&updateDateEnd=' + opts.updateDateEnd;
                    }

                    if (opts.creationDateStart !== undefined && opts.creationDateStart !== null) {
                        baseUrl += '&creationDateStart=' + opts.creationDateStart;
                    }

                    if (opts.creationDateEnd !== undefined && opts.creationDateEnd !== null) {
                        baseUrl += '&creationDateEnd=' + opts.creationDateEnd;
                    }

                    if (opts.signatureMonth !== undefined && opts.signatureMonth.length) {
                        if (opts.signatureMonth[0] !== undefined && opts.signatureMonth[0] !== null) {
                            baseUrl += '&signatureMonthStart=' + opts.signatureMonth[0];
                            if (opts.signatureMonth[1] !== null) {
                                baseUrl += '&signatureMonthEnd=' + opts.signatureMonth[1];
                            }
                        }
                    }

                    if (opts.cancelled !== undefined && opts.cancelled !== null) {
                        baseUrl += '&cancelled=' + opts.cancelled;
                    }

                    if (opts.send !== undefined && opts.send !== null) {
                        baseUrl += '&send=' + opts.send;
                    }

                    if (opts.jdsInjected !== undefined && opts.jdsInjected !== null) {
                        baseUrl += '&jdsInjected=' + opts.jdsInjected;
                    }

                    if (opts.state !== undefined && opts.state !== null) {
                        baseUrl += '&state=' + opts.state;
                    }

                    return $http.get(baseUrl).then(function(res) {
                        return res.data;
                    });
                };

                self.getContractsByStore = function(id) {
                    return $http.get(bdcUrl + 'contracts/' + id).then(function(res) {
                        return res.data;
                    });
                };

                /**
                 * Delete a contract
                 * @param  {int} id
                 * @return {Promise}
                 */
                self.deleteContract = function(id) {
                    return $http
                        .delete(bdcUrl + 'contract/' + id)
                        .then(function(res) {
                            return { info: res.data, id: id };
                        })
                        .catch(err => {
                            err.data.message = err.description;
                            return { info: err.data, id: id };
                        });
                };

                /**
                 * Send a contract
                 * @param  {int} id
                 * @param  {Object} contract
                 * @return {Promise}
                 */
                self.sendContract = function(id, contract) {
                    return $http.post(bdcUrl + 'contract/' + id + '/send', contract).then(function(res) {
                        return { info: res.data, contract: contract };
                    });
                };

                /**
                 * Cancel a contract
                 * @param  {int} id
                 * @param  {Object} contract
                 * @return {Promise}
                 */
                self.cancelContract = function(id, contract) {
                    return $http.post(bdcUrl + 'contract/' + id + '/cancel', contract).then(function(res) {
                        return { info: res.data, contract: contract };
                    });
                };

                /**
                 * Cancel and replace a contract
                 * @param  {int} id
                 * @param  {Object} contract
                 * @return {Promise}
                 */
                self.cancelReplaceContract = function(id, contract) {
                    return $http.post(bdcUrl + 'contract/' + id + '/cancelReplace', contract).then(function(res) {
                        return { info: res.data, contract: contract };
                    });
                };

                /**
                 * Cancel a contract
                 * @param  {int} id
                 * @param  {Object} contract
                 * @return {Promise}
                 */
                self.signContract = function(id, contract) {
                    return $http.post(bdcUrl + 'contract/' + id + '/sign', contract).then(function(res) {
                        return { info: res.data, contract: contract };
                    });
                };

                /**
                 * update a contract
                 * @param  {int} id
                 * @param  {Object} contract
                 * @return {Promise}
                 */
                self.saveComment = function(id, contract) {
                    return $http.put(bdcUrl + 'contract/' + id + '/comment', contract).then(function(res) {
                        return { info: res.data, contract: contract };
                    });
                };

                /**
                 * Update contract's jds injected attribute
                 * @method setJdsInjected
                 * @param  {Object} contract
                 * @param  {Boolean} value
                 * @return {Promise}
                 */
                self.setJdsInjected = function(contract, value) {
                    return $http.post(bdcUrl + 'contract/' + contract.id + '/jdsinjected', value).then(function(res) {
                        return { info: res.data, contract: contract };
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.kya.contracts.contractProvider', []).provider('contract', ContractProvider);
});
